import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetSlackAuthLinkResponse = {
	link: string;
};

export const getSlackAuthLink = createGetEndpoint<void, GetSlackAuthLinkResponse>(
	'/api/v3/slack/authorization-link'
);
